import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Flatten, T, useRespostaByPerguntaCode } from 'shared/helpers';

import Styles from './VolumeDeCompras.module.scss';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

import { Creators as reduxProdutos } from 'store/ducks/produtos';
import { Creators as reduxEtapas } from 'store/ducks/etapas';
import { Creators as reduxPerguntas } from 'store/ducks/perguntas';
import { Creators as reduxRespostas } from 'store/ducks/respostas';

import Header from 'components/Header/Header';
import Table from './Table/Table';
import PrintButton from 'components/PrintButton/PrintButton';
import { sortProducts } from 'shared/business';

export default function VolumeDeCompras({ match }) {
  const { VolumeDeCompras } = Styles;
  const { id } = match.params;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(reduxEtapas.getEtapas(id));
    dispatch(reduxProdutos.getProdutos());
    dispatch(reduxPerguntas.getPerguntas((x) => x.fase_id === 8));
    dispatch(
      reduxRespostas.getRespostas((x) => String(x.pem_id) === String(id)),
    );
  }, [id, dispatch]);

  const Perguntas = useSelector((state) => state.perguntas.data);
  const RProdutos = useSelector((state) => state.produtos.data);
  const REtapas = useSelector((state) => state.etapas.data);
  const Respostas = useSelector((state) => state.respostas.data);

  const totalArea = useRespostaByPerguntaCode(Perguntas, Respostas, 'areaTotal');
  const productionUnit = useRespostaByPerguntaCode(Perguntas, Respostas, 'unidadeProducao');

  const Etapas = REtapas.map((x) => ({
    ...x,
    produtos: x.produtos
      .filter((y) => y.fase_id === 2)
      .map((z) => ({
        ...z,
        quantidade: Number(z.quantidade),
        valor: Number(z.valor),
        classificacao: T(T(RProdutos, []).find(a => a.id === z.id)).classificacao,
        nome: T(T(RProdutos, []).find(a => a.id === z.id)).nome,
      })),
  }));

  const Produtos = Flatten(
    Etapas.map((x) => x.produtos),
    (prods, x) => prods.find((y) => y.id === x.id),
    (x, y) => (x.quantidade += y.quantidade),
  );

  const data = sortProducts(Produtos).map(x => ({
    id: x.id || x._id,
    nome: x.nome,
    dose: x.quantidade,
    volume: totalArea * x.quantidade,
  }));

  return (
    <div className={VolumeDeCompras}>
      <Header title={'VOLUME DE COMPRAS'} icon={faShoppingCart}>
        <PrintButton />
      </Header>
      <Table
        data={data}
        totalArea={totalArea}
        productionUnit={productionUnit}
      />
    </div>
  );
}

VolumeDeCompras.propTypes = {
  match: PropTypes.any.isRequired,
};
